<template>
    <div class="text-center">
        <stripe-terminal-reader />
        <submit-button
            :processing="processing"
            color="green"
            @click="!cardDetails ? collectCardDetails() : registerCanvassedCustomer()">
            {{ buttonCopy }}
        </submit-button>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import SubmitButton from '@/components/forms/buttons/SubmitButton';
import StripeTerminalReader from '../cardDetails/StripeTerminalReader';

export default {
    name: 'StripeTerminalForm',
    components: {
        SubmitButton,
        StripeTerminalReader,
    },
    data() {
        return {
            processing: false,
        };
    },
    computed: {
        ...mapGetters({
            fullName: 'register/getFullName',
            cardDetails: 'canvasser/getCardDetails',
        }),
        buttonCopy() {
            return !this.cardDetails ? this.$t('SAVE_CARD') : this.$t('CARD_DETAILS_FORM_SIGN_ME_UP');
        },
    },
    methods: {
        ...mapActions({
            collectCardDetails: 'canvasser/collectCardDetails',
        }),
        registerCanvassedCustomer() {
            this.processing = true;
            const tokenId = this.cardDetails?.payment_method;
            const cardId = this.cardDetails?.payment_method;
            const customerId = this.cardDetails?.customer;
            this.$emit('register', tokenId, cardId, customerId);
        },
    },
};
</script>
